export interface IAppConfig {
    tomcatWebAppUrl: string
    apiGatewayEndpoint: string
    reactWebAppUrl: string
}

const AppConfigs: Record<string, IAppConfig> = {
    Devo: {
        tomcatWebAppUrl: 'https://christmaslist.michaelsutton.net',
        apiGatewayEndpoint: 'https://api.devo.christmaslist.michaelsutton.net',
        reactWebAppUrl: 'https://website.devo.christmaslist.michaelsutton.net',
    },
    Prod: {
        tomcatWebAppUrl: 'https://christmaslist.michaelsutton.net',
        apiGatewayEndpoint: 'https://api.christmaslist.michaelsutton.net',
        reactWebAppUrl: 'https://website.christmaslist.michaelsutton.net',
    }
}
export const AppConfig = process.env.NODE_ENV === 'development' ? AppConfigs.Devo : AppConfigs.Prod;